import { RefundModel } from 'api-hooks/refund/refund';
import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import { HeaderCheckbox } from 'legacy-modules/sales/reschedule/header-checkbox';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

interface Props {
  parentIndex: number;
  refund?: RefundModel;
}

function reducer(state, action, { update, clearErrors, name, setValue }) {
  switch (action.type) {
    case 'update_cell':
      return {
        ...state,
        data: state.data.map((row, index) => {
          if (index === action.rowIndex) {
            const tempValue = {
              ...state.data[action.rowIndex],
              [action.columnId]: action.value,
              // ...otherVal(),
            };
            // update(index, tempValue);
            clearErrors(name);
            setValue(`${name}.${index}`, tempValue, { shouldValidate: true });
            return tempValue;
          }
          return row;
        }),
      };
    case 'update_all':
      return {
        ...state,
        data: action.newData,
      };
    case 'isSelected':
      return {
        ...state,
        data: state.data.map((row, index) => {
          const tempValue = {
            ...state.data[index],
            isSelected: action.value,
          };
          clearErrors(name);
          setValue(`${name}.${index}`, tempValue, { shouldValidate: true });

          // update(index, tempValue);
          return tempValue;
        }),
      };
    default:
      return state;
  }
}

const _columns: (props: {
  t: any;
  editable?: boolean;
  name: string;
  dispatch;
}) => IColumn<any>[] = ({ editable, t, dispatch, name }) => [
  {
    header: () => <HeaderCheckbox name={name} dispatch={dispatch} />,
    accessorKey: 'isSelected',
    minSize: 50,
    size: 50,
    checkboxNoLabel: true,
    dataType: ColumnDataType.checkbox,
  },
  {
    header: t('common:guest'),
    accessorKey: 'guestName',
    minSize: 150,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:ticket'),
    accessorKey: 'ticket',
    minSize: 100,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:airline'),
    accessorKey: 'airlineName',
    minSize: 100,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:date'),
    accessorKey: 'date',
    minSize: 100,
    dataType: ColumnDataType.date,
    disabled: true,
  },
  {
    header: t('common:detail'),
    accessorKey: 'detail',
    minSize: 100,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:class'),
    accessorKey: 'preferenceName',
    minSize: 200,
    dataType: ColumnDataType.text,

    disabled: true,
  },
  {
    header: t('common:route'),
    accessorKey: 'route',
    minSize: 100,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:time'),
    accessorKey: 'time',
    minSize: 100,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:price'),
    accessorKey: 'price',
    minSize: 100,
    dataType: ColumnDataType.number,
    minNumber: 0,
    disabled: true,
  },
  {
    header: t('common:refund_price'),
    accessorKey: 'refundPrice',
    minSize: 100,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
];

export default function GuestFlightTable(props: Props) {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const {
    control,
    formState: { isSubmitting },
    clearErrors,
    setValue,
  } = useFormContext<any>();

  //TODO CHANGE NAME
  const name: any = `flightPurchases.${props.parentIndex}.flightPurchaseGuests`;

  const [isInitiate, setIsInitiate] = React.useState<{
    value: boolean;
    data: any;
  }>({ value: false, data: undefined });

  const { fields, update } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const columns = (dispatch?: any) => _columns({ t, editable, dispatch, name });

  const [state, dispatch] = React.useReducer(
    (state, action) =>
      reducer(state, action, { update, clearErrors, name, setValue }),
    {
      columns: columns(),
      data: [],
    },
  );

  React.useEffect(() => {
    if (!isInitiate.value) {
      dispatch({
        type: 'update_all',
        newData: fields.length ? fields : [],
      });
      setIsInitiate({
        value: true,
        data: fields.length ? fields : [],
      });
    }
  }, [fields, isInitiate]);

  React.useEffect(() => {
    if (!editable && isInitiate.value && !isSubmitting) {
      dispatch({ type: 'update_all', newData: isInitiate.data });
    }
  }, [editable, isInitiate.value, isSubmitting, t, isInitiate.data]);

  if (fields.length === 0) {
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns(dispatch) as any}
        data={state.data}
        dispatch={dispatch}
        name={name}
        disabled={!editable || !!props.refund}
        uniqueRowKey="customId"
        onCustomDisabledCell={({ accessorKey, rowOriginal }) =>
          !!(accessorKey !== 'isSelected' && !rowOriginal.isSelected)
        }
        noAddRemoveRow
      />
    </div>
  );
}
